'use strict';

const appendListMethod = require('../appendListMethod');

const CONTEXTS = {
  USER: 'User',
};

const RESOURCES = {
  ACTIVITY: 'Activity',
  CHALLENGE: 'Challenge',
  RANKING: 'Ranking',
  REWARD: 'Reward',
  USER_APP: 'UserApp',
  USER_GROUP: 'UserGroup',
};

module.exports = {
  AVAILABLE_FEED_CONTEXTS: appendListMethod(CONTEXTS),
  AVAILABLE_FEED_RESOURCES: appendListMethod(RESOURCES),
  FEED_CONTEXTS: CONTEXTS,
  FEED_RESOURCES: RESOURCES,
};
